export default "__VITE_ASSET__08e3787f__"